import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { HiCheckCircle, HiAcademicCap, HiUsers } from 'react-icons/hi'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair } from '../../utils/seoUtils'
import './Membership.css'

function Membership() {
  const { t } = useTranslation()
  const getLocalizedLink = useLocalizedLink()

  const breadcrumbItems = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.membership'), 'membership'),
    [t]
  )

  return (
    <div className="membership-page">
      <SEO 
        title={t('common.membership')}
        description={t('membership.description', 'Join SUMA International')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <div className="membership-hero">
          <h1>{t('common.membership')}</h1>
          <p className="membership-intro">
            {t('membership.intro', 'Join SUMA International and become part of a global community of martial arts schools and federations.')}
          </p>
        </div>

        <div className="membership-types">
          <div className="membership-card">
            <HiAcademicCap className="membership-icon" />
            <h2>{t('membership.schoolMembership', 'School Membership')}</h2>
            <p>{t('membership.schoolText', 'Martial arts schools can join SUMA International to access certification programs, participate in events, and connect with the global community.')}</p>
            <ul className="benefits-list">
              <li><HiCheckCircle /> {t('membership.benefit1', 'Access to certification programs')}</li>
              <li><HiCheckCircle /> {t('membership.benefit2', 'Participation in competitions and events')}</li>
              <li><HiCheckCircle /> {t('membership.benefit3', 'Recognition and listing on the website')}</li>
              <li><HiCheckCircle /> {t('membership.benefit4', 'Access to training materials and resources')}</li>
            </ul>
            <Link to={getLocalizedLink('/contact')} className="btn btn-primary">
              {t('membership.apply', 'Apply for Membership')}
            </Link>
          </div>

          <div className="membership-card">
            <HiUsers className="membership-icon" />
            <h2>{t('membership.federationMembership', 'Federation Membership')}</h2>
            <p>{t('membership.federationText', 'Federations can join SUMA International to represent their discipline and coordinate activities across member schools.')}</p>
            <ul className="benefits-list">
              <li><HiCheckCircle /> {t('membership.fedBenefit1', 'Representation of your discipline')}</li>
              <li><HiCheckCircle /> {t('membership.fedBenefit2', 'Coordination of member schools')}</li>
              <li><HiCheckCircle /> {t('membership.fedBenefit3', 'Development of standards and programs')}</li>
              <li><HiCheckCircle /> {t('membership.fedBenefit4', 'International recognition')}</li>
            </ul>
            <Link to={getLocalizedLink('/contact')} className="btn btn-primary">
              {t('membership.apply', 'Apply for Membership')}
            </Link>
          </div>
        </div>

        <section className="membership-section">
          <h2>{t('membership.requirements', 'Membership Requirements')}</h2>
          <div className="requirements-content">
            <p>{t('membership.requirementsText', 'To become a member of SUMA International, schools and federations must meet certain standards and requirements.')}</p>
            <Link to={getLocalizedLink('/documents')} className="btn btn-secondary">
              {t('membership.viewDocuments', 'View Requirements Documents')}
            </Link>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Membership
